import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { AppConstants } from '@core/constants';
import { EditTzbDialogData, TzbDataRow } from '@shared/interfaces/edit-tzb-dialog.interface';
import { TextEditorComponent } from '@modules/administration/report-template/text-editor/text-editor.component';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-edit-tzb-dialog',
  templateUrl: './edit-tzb-dialog.component.html',
  styleUrls: ['./edit-tzb-dialog.component.scss'],
})
export class EditTzbDialogComponent {
  @ViewChild(TextEditorComponent) textEditorComponent: TextEditorComponent;

  private readonly dialogRef = inject(MatDialogRef<EditTzbDialogComponent>);
  private readonly fb = inject(FormBuilder);

  @Input() id: string = '';
  @Input() width: number = 250;

  PREVIEW_PDF: string = AppConstants.TEXT_EDITOR_VIEW_TYPE.PREVIEW_PDF;
  textFromEditor: string = '';
  canEditContent: boolean = true;
  canEditHeading: boolean = true;
  rowOptions: Array<TzbDataRow>;
  form: FormGroup;

  data: EditTzbDialogData = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.textFromEditor = this.data.content;
    this.canEditContent = this.data.canEditContent ?? true;
    this.canEditHeading = this.data.canEditHeading ?? true;
    this.rowOptions = this.data.allRows ?? [];

    this.form = this.fb.group({
      heading: [this.data.heading],
      zones: [this.data.selectedRows ?? []],
    });
  }

  onUpdate(): void {
    let content: string = '';
    try {
      content = this.textEditorComponent.getModel();
    } catch (TypeError) {
      content = '';
    }

    const heading = this.form.value.heading;
    const selectedRows = this.form.value.zones;
    this.dialogRef.close({ heading, content, selectedRows });
  }

  onSelectZone(value: any): void {
    this.form.get('zones')?.setValue(value);
  }
}
